import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import "./BarChartMixed.scss";
import CustomTooltip from "../customTooltip";

// biblioteca https://ui.shadcn.com/charts

export default function BarChartMixed(props) {
  const [data, setData] = useState();
  const [yAxisWidth, setYAxisWidth] = useState(60); // valor inicial

  useEffect(() => {
    const container = document.querySelector(".barchartmixed");
    const style = getComputedStyle(container);

    const novaArray = props.chartData.map((item, index) => {
      const varIndex = (index % 5) + 1; // 1 a 5
      const cor = `hsl(${style
        .getPropertyValue(`--chart-${varIndex}`)
        .trim()})`;

      return {
        ...item,
        fill: item.fill || cor,
      };
    });
    // Ordena os dados pela chave ou total para garantir a ordem da esquerda para a direita
    // .sort((a, b) => b[props.dataKeyX] - a[props.dataKeyX]); // Ordenando por total (ou qualquer métrica)
    setData(novaArray);

    // Calcular maior largura de texto
    const maxLabel = Math.max(
      ...props.chartData.map((item) => item[props.YDataKey]?.length),
    );
    const fontSize = props.YFontSize;
    const estimatedWidth = maxLabel * (fontSize * 0.6); // estimativa
    setYAxisWidth(Math.max(60, estimatedWidth + 10)); // largura mínima 60
  }, [props.chartData]);

  return (
    <>
      {props.title !== null && (
        <p className="titleBarchartMixed">{props.title}</p>
      )}
      {data?.length > 0 ? (
        <div
          className="barchartmixed"
          style={{ width: "100%", height: props.height }}
        >
          <ResponsiveContainer width="100%" height={data.length * 40}>
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 5, right: 20, bottom: 5, left: 0 }} //Margin Para não quebrar o grafico
            >
              {/* Mostrar linhas do fundo. */}
              <CartesianGrid vertical={false} horizontal={false} />
              <YAxis
                className={`${props.cursorpoint ? "cursorp" : ""}`}
                dataKey={props.YDataKey}
                type="category"
                axisLine={false} //Remove linhas verticais
                tickLine={false} //Remove o traço
                width={yAxisWidth} // << Aumente esse valor (padrão é ~60)
                tick={{
                  fill: "var(--color-018-01)",
                  fontSize: props.YFontSize,
                }}
                onClick={(data, index) => {
                  props.functionClick(data);
                }}
              />
              <XAxis dataKey={props.BarDataKey} type="number" hide />
              <Tooltip
                content={<CustomTooltip />}
                cursor={false} //Remove o fundo branco.
              />
              <Bar
                className={`barras ${props.cursorpoint ? "cursorp" : ""}`}
                dataKey={props.BarDataKey}
                radius={5} //radius para as barras.
                fill={({ payload }) => payload.fill}
                label={{
                  position: "right",
                  fill: "var(--color-018-01)",
                  fontSize: props.BarFontSize,
                }}
                {...(props.BarSize !== null && { barSize: props.BarSize })}
                onClick={(data, index) => {
                  props.functionClick(data);
                }}
              />
              {props.duasColunas && (
                <Bar
                  className={`barras ${props.cursorpoint ? "cursorp" : ""}`}
                  dataKey={props.BarDataKey2}
                  radius={5} //radius para as barras.
                  fill={({ payload }) => payload.fill}
                  label={{
                    position: "right",
                    fill: "var(--color-018-01)",
                    fontSize: props.BarFontSize,
                  }}
                  {...(props.BarSize2 !== null && { barSize: props.BarSize2 })}
                  onClick={(data, index) => {
                    props.functionClick(data);
                  }}
                />
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="barchartmixed semdados">
          <p>sem dados</p>
        </div>
      )}
    </>
  );
}
BarChartMixed.defaultProps = {
  // BarChart
  duasColunas: false,
  chartData: [
    { browser: "Chrome", visitors: 375, fill: "" },
    { browser: "Safari", visitors: 200, fill: "" },
    { browser: "Firefox", visitors: 187, fill: "" },
    { browser: "Edge", visitors: 173, fill: "" },
    { browser: "Other", visitors: 90, fill: "#fff" },
  ],
  height: null,
  // YAxis
  YDataKey: "browser",
  YFontSize: 16,
  // Bar
  BarDataKey: "visitors",
  BarDataKey2: "",
  BarSize: null,
  BarSize2: null,
  BarFontSize: 16,
  functionClick: () => null,
  cursorpoint: true,
  title: "Historico",
};
